import { Link } from 'react-router-dom';

import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from '../../../components/sidebar/Sidebar';

import Criteria from "../../../pages/criteria/criteria";

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';

const AdminCriteriaSection = () => {
	const overflowedBtnsCount = 0;

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content="Легенда"
					purpose="legend"
					modalTitle="Легенда"
				/>
			),
		},
	];

	const filteredAvailableButtons = availableButtons.filter((btn: { component: JSX.Element }) => btn);

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				headBlockChildren={displayedHeadBtns}
				pageName='reports'
				section='Критерии'
			>
				<div className="content__main">
					<div className='btns btns_map' >
						<Link to={'/criteria'} className='tab'>
							<div className='buttons__btn  --active'>Контракт</div>
						</Link>
					</div>
					<div className='content__single_report'>
						<div style={{ height: '15px' }} />
						<Criteria />
					</div>
				</div>
			</SectionContent>
		</div>
	);
};

export default AdminCriteriaSection;